export default __webpack_public_path__ + "static/brand-003-986837d6f0fb60460721df7999583346.png";